var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditTextIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5609 7.70833L13.0817 6.22917L13.6859 5.625C13.797 5.51389 13.9428 5.45833 14.1234 5.45833C14.3039 5.45833 14.4498 5.51389 14.5609 5.625L15.165 6.22917C15.2761 6.34028 15.3317 6.48611 15.3317 6.66667C15.3317 6.84722 15.2761 6.99306 15.165 7.10417L14.5609 7.70833ZM7.79004 13V11.5208L12.1859 7.125L13.665 8.60417L9.26921 13H7.79004ZM0.290039 8.625V7.375H6.54004V8.625H0.290039ZM0.290039 5.1875V3.9375H10.0817V5.1875H0.290039ZM0.290039 1.75V0.5H10.0817V1.75H0.290039Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTextIcon);
export default __webpack_public_path__ + "static/media/edit_text_icon.4b7fb424.svg";
export { ForwardRef as ReactComponent };